export const SubscriptionFares = Object.freeze({
    MONTH: "zaycev__month",
    YEAR: "zaycev__year"
})